import { TraitTypeSelectWithPreview } from '../traitTypes/TraitTypeSelectWithPreview';
import { TraitTypeNumericWithSlider } from '../traitTypes/TraitTypeNumericWithSlider';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
import { TraitTypeNumeric } from '../traitTypes/TraitTypeNumeric';
export class TraitRegistryCssDisplay extends TraitRegistryCategory {
    label = 'Display';
    constructor(parent) {
        super(parent);
        super.init();
    }
    cursor = () => new TraitTypeSelectWithPreview({
        default: 'auto' /*
      label: 'Cursor',
      select: () =>
        [
          'auto',
          'pointer',
          'default',
          'move',
          'alias',
          'all-scroll',
          'cell',
          'context-menu',
          'copy',
          'crosshair',
          'grab',
          'grabbing',
          'help',
          'no-drop',
          'none',
          'not-allowed',
          'progress',
          'text',
          'wait',
          'zoom-in',
          'zoom-out',
          'col-resize',
          'e-resize',
          'ew-resize',
          'n-resize',
          'ne-resize',
          'nesw-resize',
          'ns-resize',
          'nw-resize',
          'nwse-resize',
          'row-resize',
          's-resize',
          'se-resize',
          'sw-resize',
          'vertical-text',
          'w-resize'
        ].map(s => {
          const r: TraitRegistrySelectWithPreviewItem = [
            s,
            s,
            {
              onMouseEnter: ({ selectItemComp }) => selectItemComp.dynamicstyles.set('cursor', s),
              onMouseLeave: ({ selectItemComp }) => selectItemComp.dynamicstyles.delete('cursor')
            }
          ];
          return r;
        }) */
    });
    opacity = () => new TraitTypeNumericWithSlider({
        default: 1
        /*  label: 'Transparenz',
        step: 0.01,
        init: 0.85,
        min: 0,
        max: 1 */
    });
    overflow = () => new TraitTypeSelect({
        default: 'visible'
        /*  label: 'Überfluss',
        select: [
          ['visible', 'Sichtbar'],
          ['hidden', 'Nicht sichtbar'],
          ['scroll', 'Scrollleiste'],
          ['auto', 'Automatisch']
        ] */
    });
    visibility = () => new TraitTypeSelect({
        default: 'visible'
        /* label: 'Sichtbarkeit',
        init: 'hidden',
        select: [['visible', 'Sichtbar'], ['hidden', 'Nicht sichtbar']] */
    });
    zIndex = () => new TraitTypeNumeric( /*{
      label: 'zIndex',
      step: 1,
      default: 1,
      init: 100,
      min: 1,
      max: 99999
    }*/);
}
